import React from "react";
import { ButtonGroup, styled, Typography } from "@mui/material";
import { COLORS } from "components/consts";

const StyledButtonGroup = styled(ButtonGroup)(() => ({
    borderRadius: '30px',
    overflow: 'hidden',
    border: `1px solid ${COLORS.Romance}`,
    width: '212px',
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: '42px'
}));

const StyledButton = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    cursor: 'pointer',
    textTransform: 'none',
    padding: '0px 14px',
    borderRadius: 30,
    border: 'none',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center',
    fontFamily: 'Inter',
    fontWeight: '600',
    '&:not(:last-of-type)': {
        borderRight: `1px solid ${theme.palette.divider}`,
        border: 'none'
    },
    '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        border: 'none',
        height: '32px',
    },
    '&:not(.Mui-selected)': {
        backgroundColor: 'transparent',
        color: COLORS.Romance50,
        border: 'none',
    },
}));

interface ToggleButtonOption {
    value: string;
    label: string;
}

interface ToggleButtonGroupProps {
    options: ToggleButtonOption[];
    selectedValue: string;
    onValueChange: (value: string) => void;
    width?: string;
    height?: string;
    className?: string;
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
    options,
    selectedValue,
    onValueChange,
    width = '212px',
    height = '42px',
    className
}) => (
    <StyledButtonGroup
        sx={{ width, height }}
        className={className}
    >
        {options.map((option) => (
            <StyledButton
                key={option.value}
                className={selectedValue === option.value ? 'Mui-selected' : ''}
                onClick={() => onValueChange(option.value)}
            >
                {option.label}
            </StyledButton>
        ))}
    </StyledButtonGroup>
); 